import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import { MgsaDraftStateFragmentDoc } from './mgsaDraft';
export type MgsaForEditorFragment = { id: string, entityId: string, entityType: Types.MgsaEntityTypeEnum, orgRoleId?: string | null, status: Types.MgsaStatusEnum, updatedAt: string, draftState?: { mindsets?: Array<{ name: string, description?: string | null }> | null, goals?: Array<{ name: string, description?: string | null }> | null, skillGroups?: Array<{ skillGroupName: string, skills: Array<{ description?: string | null, expectedScore: number, name: string, reviewerScore: number }> }> | null, activities?: Array<{ activityEntityId?: string | null, activityType: Types.MgsaActivityTypeEnum, description?: string | null, draftOkr?: string | null }> | null, overriddenMgsaPropertiesConfig?: { skillOverridden?: boolean | null, mindsetOverridden?: boolean | null, goalOverridden?: boolean | null, activityOverridden?: boolean | null } | null } | null };


export type MgsaForEditorFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const MgsaForEditorFragmentDoc = /*#__PURE__*/ gql`
    fragment MgsaForEditor on MgsaType {
  id
  entityId
  entityType
  orgRoleId
  status
  updatedAt
  draftState {
    ...MgsaDraftState
  }
}
    `;